import React from 'react';
import { Link } from 'react-router-dom';
import Hint from '../../components/Hint';
import { getFullDate } from '../../common/date';
import ReactTooltip from 'react-tooltip';
const UserListing = ({
	type,
	created_at,
	updated_at,
	last_login_at,
	is_active,
	inactive_reason,
	email,
	full_name,
	mobile_no,
	role_name,
	f_name,
	user_id,
	branch_name,
	// employee_code,
	toggleModal,
	setSelectedUserId,
	checkHasPermission,
	pageType,
}) => {

	return (
		<tr>
			<td>{user_id}</td>
			<td>{full_name}</td>
			{type === 'admin' && (
				<>
					<td>{email}</td>
					<td>{mobile_no}</td>
					<td>{role_name}</td>
				</>
			)}
			<td>{last_login_at && getFullDate(new Date(last_login_at))}</td>
			<td>{created_at && getFullDate(new Date(created_at))}</td>
			<td>{updated_at && getFullDate(new Date(updated_at))}</td>
			<td>
				{' '}
				<span className={is_active ? 'text-success' : 'text-warning'}>
					{is_active ? 'Active' : <>In active <Hint text={inactive_reason} id={'reason'} place={'left'} /> </>}
				</span>
			</td>
			{type === 'affiliate' && (
				<td>
					<a
						href='#'
						onClick={(e) => {
							e.preventDefault();
							setSelectedUserId(user_id);
							toggleModal(true);
						}}
					>
						Edit
					</a>
				</td>
			)}
			{type === 'admin' && (
				<td>
					<ReactTooltip id='view'>View</ReactTooltip>
					<ReactTooltip id='edit'>Edit</ReactTooltip>
					{checkHasPermission('update-backend-user') && (
						<Link to={`/admin/manage-users/edit/${user_id}`}>
							<i className='fa fa-pencil fa-lg mr-2' style={{ color: '#4A4E88' }}
								data-tip
								data-for='edit'>
							</i>
						</Link>
					)}
					{checkHasPermission('view-backend-user') && (
						<Link to={`/admin/manage-users/${user_id}`}>
							<i className='fa fa-eye fa-lg' style={{ color: '#4A4E88' }}
								data-tip
								data-for='view'
							></i>
						</Link>
					)}
				</td>
			)}
			{pageType === 'lender' && (
				<td>
					{<Link to={`/lender/manage-users/edit/${user_id}`}>Edit</Link>}/
					{<Link to={`/lender/manage-users/${user_id}`}>View</Link>}
				</td>
			)}
		</tr>
	);
};

export default UserListing;
